import { Autoplay, Thumbs, Controller, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, Navigation, Pagination, Thumbs]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  //サムネイルスライド
  var thumbs = new Swiper('.js-sliderMV-thumb', {
    freeMode: true,
    slidesPerView: 4,
    spaceBetween: 4,
    //各スライドの進行状況を監視
    watchSlidesProgress: true,
    //ビューポートにあるスライドに表示クラスを追加
    watchSlidesVisibility: true,
    //カーソルをデフォルトから grab に変更
    grabCursor: true,
  })

  //メインスライド
  var slider = new Swiper('.js-sliderMV', {
    loop: true,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      //サムネイルのスライダーを指定
      swiper: thumbs,
    },
    //ページネーション表示の設定
    pagination: {
      el: '.swiper-pagination', //ページネーションの要素
      type: 'bullets', //ページネーションの種類
      clickable: true, //クリックに反応させる
    },
  })
}

var sliderBrand = new Swiper('.js-brands', {
  loop: true,
  slidesPerView: 2, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
  spaceBetween: 10, // スライド間の余白（px）
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    // ブレークポイント
    1025: {
      // 画面幅1025px以上で適用
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
})

// var sliderProduct = new Swiper('.js-sliderProduct', {
//   loop: true,
//   slidesPerView: 2, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
//   spaceBetween: 10, // スライド間の余白（px）
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   breakpoints: {
//     // ブレークポイント
//     1025: {
//       // 画面幅1025px以上で適用
//       slidesPerView: 4,
//       spaceBetween: 20,
//     },
//   },
// })

document.querySelectorAll('.js-sliderProduct').forEach((slider) => {
  const sliderId = slider.getAttribute('data-slider-id')
  const slidesPerView = parseInt(slider.getAttribute('data-slides-per-view')) || 1
  const slidesPerViewSP = parseInt(slider.getAttribute('data-slides-per-view_sp')) || 3

  new Swiper(slider, {
    loop: true,
    slidesPerView: slidesPerViewSP,
    spaceBetween: 10,
    navigation: {
      nextEl: `.swiper-button-next[data-slider-id="${sliderId}"]`,
      prevEl: `.swiper-button-prev[data-slider-id="${sliderId}"]`,
    },
    breakpoints: {
      // ブレークポイント
      1025: {
        // 画面幅1025px以上で適用
        slidesPerView: slidesPerView,
        spaceBetween: 20,
      },
    },
  })
})

//==========================================================================================
//
//  #####     ###     ####  ##  ##        ######   #####         ######   #####   #####
//  ##  ##   ## ##   ##     ## ##           ##    ##   ##          ##    ##   ##  ##  ##
//  #####   ##   ##  ##     ####            ##    ##   ##          ##    ##   ##  #####
//  ##  ##  #######  ##     ## ##           ##    ##   ##          ##    ##   ##  ##
//  #####   ##   ##   ####  ##  ##          ##     #####           ##     #####   ##
//
//==========================================================================================
const backToTop = document.querySelector('.back2top')
backToTop.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
})

if (document.getElementsByClassName('js-product-slider')[0]) {
  //商品詳細ページのスライダー
  let productSliderThumbs = new Swiper('.js-product-slider-nav', {
    slidesPerView: 4,
    spaceBetween: 6,
    breakpoints: {
      // ブレークポイント
      769: {
        // 画面幅769px以上で適用
        slidesPerView: 5,
        spaceBetween: 4,
      },
    },
  })

  let productSlider = new Swiper('.js-product-slider', {
    loop: true,
    thumbs: {
      //サムネイル
      swiper: productSliderThumbs,
    },
  })
}
